import { AccessibilityShortcuts } from '@/components/features/accessibility/accessibility-shortcuts'
import { IneraHeader } from '@/components/features/header/header'
import BuildInfoData from '@platformui/core/components/build-info/build-info'
import { SurveyEntry } from '@platformui/core/components/survey-entry/survey-entry'
import { IDSFooterInera } from '@platformui/core/ids/footer-inera/footer-inera'
import { usePageInfo } from '@platformui/core/infrastructure/features/page-info/page-info-hook'
import { ComponentType, FC, useEffect, useState } from 'react'
import { ScrollToTop } from '@platformui/core/components/scroll-to-top/scroll-to-top'
import '@/components/scroll-to-top/scroll-to-top.scss'
import { MatomoTrackDataAttribute } from '@platformui/core/components/matomo/matomo-track-data-attribute'
import { MatomoTrackMediaAnalytics } from '@platformui/core/components/matomo/matomo-track-media-analytics'

export type LayoutProps = {
    Page: ComponentType
}

export const Layout: FC<LayoutProps> = ({ Page }) => {
    const { siteFooter, surveyEntries, buildInfo, translations } = usePageInfo()
    const activeSurvey = surveyEntries?.find((survey) => survey.isActive)
    const [hasBuildInfo, setBuildInfo] = useState(false)

    useEffect(() => {
        if (buildInfo) {
            setBuildInfo(true)
        }
    }, [buildInfo])

    return (
        <div>
            <AccessibilityShortcuts />
            {hasBuildInfo && <BuildInfoData {...buildInfo} />}
            <div className="ids ids-content ids-typography">
                <IneraHeader />
                <div className="main-wrapper">
                    {activeSurvey && <SurveyEntry {...activeSurvey} />}
                    <Page />
                    <ScrollToTop key="scrolltop" translations={translations} />
                </div>
                <IDSFooterInera {...siteFooter} />
            </div>
            <MatomoTrackDataAttribute />
            <MatomoTrackMediaAnalytics />
        </div>
    )
}
